import { useEffect } from 'react';
import usePageTracking from './usePageTracking';
var usePageTrackingImpression = function (newSurface) {
    var fireImpressionEvent = usePageTracking(newSurface).fireImpressionEvent;
    useEffect(function () {
        fireImpressionEvent({});
        // Intentionally only want to fire this effect only once per page load.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
export default usePageTrackingImpression;
